/* eslint-disable max-len -- Keep localized catalogue sentences together. */
export const moveLabels = {
  en: {
    title: 'Move to active-access billing',
    context: 'PALMHR MANAGEMENT · SUBSCRIPTION',
    starts: 'Access billing starts',
    now: 'On confirmation',
    ends: 'Current term ends',
    rates: 'Rates per purchased seat',
    active: 'Active access',
    inactive: 'Inactive employee record',
    existing: 'existing Core rate',
    launch: 'launch terms',
    approved: 'approved terms',
    unsupported: 'Not supported — billing setup required',
    seats: 'Purchased seats stay unchanged',
    capacity: 'Capacity',
    purchased: 'Purchased',
    needed: 'Needed now',
    enabled: 'Enabled access',
    reserved: 'Reserved active seats for existing inactive employees',
    total: 'Total active capacity required',
    inactiveSeats: 'Inactive seats',
    released: 'Reserved seat release date',
    renewal: 'ordinary renewal',
    covered: '✓ Purchased capacity covers this move',
    shortfall: 'Purchased capacity does not cover this move',
    charge: 'Charge for this move',
    invoices: 'Invoices',
    addons: 'Add-ons',
    dates: 'Payment dates',
    unchanged: '✓ Unchanged',
    safeguards: 'Source and safeguards',
    observed: 'Observed',
    cancel: 'Cancel',
    confirm: 'Confirm move',
    refresh: 'Refresh preview',
    edit: 'Edit purchased seats',
    loading: 'Loading billing preview…',
    sending: 'Moving…',
    failed: 'The result could not be confirmed. Retry with the same request.',
    unavailable: 'Billing provider unavailable. Refresh preview to try again.',
    blocked: 'Setup blocked. Billing administrator review required.',
    pending: 'Setup pending — reconciliation required',
    configured: 'Already using active-access billing',
    success: 'Moved to active-access billing',
    stale: 'This preview has changed. Refresh before confirming.',
    paused: 'Paused',
    expansion: 'Capacity expansion',
    dispatch: 'Billing dispatch',
    handoff: 'Renewal handoff',
    legacy: 'Legacy billing',
    transition: 'Transition',
    supported: 'Active-access billing',
    setup: 'Setup pending',
    effective: 'Inactive rate effective',
    close: 'Close',
    month: 'month',
    year: 'year',
    week: 'week',
    day: 'day',
  },
  ar: {
    title: 'الانتقال إلى فوترة الوصول النشط',
    context: 'إدارة بالم إتش آر · الاشتراك',
    starts: 'بدء فوترة الوصول',
    now: 'عند التأكيد',
    ends: 'نهاية الفترة الحالية',
    rates: 'الأسعار لكل مقعد مشترى',
    active: 'الوصول النشط',
    inactive: 'سجل الموظف غير النشط',
    existing: 'سعر الاشتراك الأساسي الحالي',
    launch: 'شروط الإطلاق',
    approved: 'الشروط المعتمدة',
    unsupported: 'غير مدعوم — يلزم إعداد الفوترة',
    seats: 'المقاعد المشتراة دون تغيير',
    capacity: 'السعة',
    purchased: 'المشترى',
    needed: 'المطلوب الآن',
    enabled: 'الوصول المفعّل',
    reserved: 'المقاعد النشطة المحجوزة للموظفين الحاليين غير النشطين',
    total: 'إجمالي السعة النشطة المطلوبة',
    inactiveSeats: 'المقاعد غير النشطة',
    released: 'تحرير المقاعد المحجوزة',
    renewal: 'التجديد المعتاد',
    covered: '✓ السعة المشتراة تغطي هذا الانتقال',
    shortfall: 'السعة المشتراة لا تغطي هذا الانتقال',
    charge: 'تكلفة هذا الانتقال',
    invoices: 'الفواتير',
    addons: 'الإضافات',
    dates: 'تواريخ الدفع',
    unchanged: '✓ دون تغيير',
    safeguards: 'المصدر والضمانات',
    observed: 'وقت التحقق',
    cancel: 'إلغاء',
    confirm: 'تأكيد الانتقال',
    refresh: 'تحديث المعاينة',
    edit: 'تعديل المقاعد المشتراة',
    loading: 'جارٍ تحميل معاينة الفوترة…',
    sending: 'جارٍ الانتقال…',
    failed: 'تعذر تأكيد النتيجة. أعد المحاولة بالطلب نفسه.',
    unavailable: 'مزود الفوترة غير متاح. حدّث المعاينة للمحاولة مجددًا.',
    blocked: 'الإعداد محظور. يلزم مراجعة مسؤول الفوترة.',
    pending: 'الإعداد معلق — يلزم التحقق من التسوية',
    configured: 'يستخدم فوترة الوصول النشط بالفعل',
    success: 'تم الانتقال إلى فوترة الوصول النشط',
    stale: 'تغيرت هذه المعاينة. حدّثها قبل التأكيد.',
    paused: 'متوقف مؤقتًا',
    expansion: 'توسيع السعة',
    dispatch: 'إرسال الفوترة',
    handoff: 'تسليم التجديد',
    legacy: 'الفوترة القديمة',
    transition: 'مرحلة انتقالية',
    supported: 'فوترة الوصول النشط',
    setup: 'الإعداد معلق',
    effective: 'سريان سعر غير النشط',
    close: 'إغلاق',
    month: 'شهر',
    year: 'سنة',
    week: 'أسبوع',
    day: 'يوم',
  },
};
